function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, closest, isEqual } from '@cloud-sn/v-utils';
import { VMenu as Menu, VSubMenu as SubMenu, VMenuItem as MenuItem } from '@cloud-sn/v-menu';
import Dropdown from '../dropdown';
import Icon from '../icon';
import Checkbox from '../checkbox';
import Radio from '../radio';
import SubMixin from './mixins/sub';
import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('filterDropdown'),
  mixins: [SubMixin],
  props: {
    dropdownPrefixCls: {
      type: String,
      default: ''
    },
    selectedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    column: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    getPopupContainer: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      innerSelectedKeys: [],
      dropdownVisible: false
    };
  },
  computed: {
    filterPrefixCls: function filterPrefixCls() {
      return "".concat(this.prefixCls, "-filter");
    },
    iconClasses: function iconClasses() {
      var _ref;

      var filterPrefixCls = this.filterPrefixCls,
          selectedKeys = this.selectedKeys,
          column = this.column;
      var filtered = 'filtered' in column ? !!column.filtered : true;
      return _ref = {}, _defineProperty(_ref, "".concat(filterPrefixCls, "-icon"), true), _defineProperty(_ref, "".concat(filterPrefixCls, "-selected"), filtered && selectedKeys.length > 0), _ref;
    },
    isMultiple: function isMultiple() {
      var column = this.column;
      return 'filterMultiple' in column ? column.filterMultiple : true;
    },
    filterIcon: function filterIcon() {
      return this.renderFilterIcon();
    },
    hasSubMenu: function hasSubMenu() {
      var _this$column$filters = this.column.filters,
          filters = _this$column$filters === void 0 ? [] : _this$column$filters;
      return filters.filter(function (v) {
        return Array.isArray(v.children) && v.children.length > 0;
      }).length > 0;
    },
    filterMenu: function filterMenu() {
      var h = this.$createElement;
      var dropdownPrefixCls = this.dropdownPrefixCls,
          isMultiple = this.isMultiple,
          _this$column$filters2 = this.column.filters,
          filters = _this$column$filters2 === void 0 ? [] : _this$column$filters2,
          renderMenus = this.renderMenus,
          innerSelectedKeys = this.innerSelectedKeys,
          setInnerSelectedKeys = this.setInnerSelectedKeys,
          hasSubMenu = this.hasSubMenu;

      if (filters.length === 0) {
        return [];
      }

      var props = {
        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
        multiple: isMultiple,
        selectedKeys: innerSelectedKeys,
        mode: 'vertical'
      };
      var on = {
        click: function click() {},
        select: function select(_ref2) {
          var selectedKeys = _ref2.selectedKeys;
          setInnerSelectedKeys(selectedKeys);
        },
        deselect: function deselect(_ref3) {
          var selectedKeys = _ref3.selectedKeys;
          setInnerSelectedKeys(selectedKeys);
        }
      };
      return h(Menu, {
        "class": _defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !hasSubMenu),
        "props": _objectSpread({}, props),
        "on": _objectSpread({}, on)
      }, [renderMenus(filters)]);
    }
  },
  watch: {
    selectedKeys: function selectedKeys(nVal) {
      if (nVal) {
        this.setInnerSelectedKeys(nVal);
      }
    },
    'column.filterDropdownVisible': function filterDropdownVisibleW(nVal, oVal) {
      if (nVal !== oVal) {
        this.initDropdownVisible();
      }
    }
  },
  mounted: function mounted() {
    this.setInnerSelectedKeys(this.selectedKeys);
    this.initDropdownVisible();
  },
  methods: {
    getFilterDropdownVisible: function getFilterDropdownVisible() {
      var column = this.column;
      var visible = false;

      if ('filterDropdownVisible' in column) {
        // 修正由于filter操作同时存在于浮动表和普通表中,导致操作异常的问题
        var isMainTable = closest(this.$el, '.ux-table-scroll');
        visible = isMainTable && !!column.fixed ? false : !!column.filterDropdownVisible;
      }

      return visible;
    },
    initDropdownVisible: function initDropdownVisible() {
      var getFilterDropdownVisible = this.getFilterDropdownVisible; // const visible = 'filterDropdownVisible' in column ? !!column.filterDropdownVisible : false;

      var visible = getFilterDropdownVisible();
      this.dropdownVisible = visible;
    },
    setDropdownVisible: function setDropdownVisible(visible) {
      var column = this.column;
      this.dropdownVisible = visible;

      if (isFunction(column.onFilterDropdownVisibleChange)) {
        column.onFilterDropdownVisibleChange(visible);
      }
    },
    setInnerSelectedKeys: function setInnerSelectedKeys(keys) {
      this.innerSelectedKeys = keys;
    },
    confirmFilter: function confirmFilter() {
      var column = this.column,
          innerSelectedKeys = this.innerSelectedKeys,
          selectedKeys = this.selectedKeys;

      if (!isEqual(innerSelectedKeys, selectedKeys)) {
        // if (innerSelectedKeys !== selectedKeys) {
        this.$emit('confirm-filter', column, innerSelectedKeys);
      }
    },
    handleConfirm: function handleConfirm() {
      var setDropdownVisible = this.setDropdownVisible,
          confirmFilter = this.confirmFilter;
      setDropdownVisible(false);
      confirmFilter();
    },
    handleClearFilters: function handleClearFilters() {
      var setInnerSelectedKeys = this.setInnerSelectedKeys,
          handleConfirm = this.handleConfirm;
      setInnerSelectedKeys([]);
      handleConfirm();
    },
    onVisibleChange: function onVisibleChange(visible) {
      var setDropdownVisible = this.setDropdownVisible,
          confirmFilter = this.confirmFilter;
      setDropdownVisible(visible);

      if (!visible) {
        confirmFilter();
      }
    },
    renderFilterIcon: function renderFilterIcon() {
      var h = this.$createElement;
      var column = this.column,
          iconClasses = this.iconClasses;
      var filterIcon = h(Icon, {
        "attrs": {
          "type": "filter"
        }
      });

      if (column.filterIcon) {
        filterIcon = isFunction(column.filterIcon) ? column.filterIcon(this.$createElement) : column.filterIcon;
      }

      return h("span", {
        "class": iconClasses,
        "attrs": {
          "title": "筛选"
        }
      }, [filterIcon]);
    },
    renderMenuItem: function renderMenuItem(item) {
      var h = this.$createElement;
      var isMultiple = this.isMultiple,
          innerSelectedKeys = this.innerSelectedKeys;
      var checked = innerSelectedKeys.indexOf(item.value) > -1;
      var input = isMultiple ? h(Checkbox, {
        "attrs": {
          "checked": checked
        }
      }) : h(Radio, {
        "attrs": {
          "checked": checked
        }
      });
      return h(MenuItem, {
        "attrs": {
          "name": item.value
        }
      }, [input, h("span", [item.text])]);
    },
    renderMenus: function renderMenus(filters) {
      var h = this.$createElement;
      var renderMenus = this.renderMenus,
          renderMenuItem = this.renderMenuItem;
      return filters.map(function (v) {
        var child = v.children;

        if (Array.isArray(child) && child.length > 0) {
          return h(SubMenu, {
            "attrs": {
              "name": v.value,
              "title": v.text
            }
          }, [renderMenus(child)]);
        }

        return renderMenuItem(v);
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var theme = this.theme,
        column = this.column,
        filterIcon = this.filterIcon,
        filterMenu = this.filterMenu,
        filterPrefixCls = this.filterPrefixCls,
        handleConfirm = this.handleConfirm,
        handleClearFilters = this.handleClearFilters,
        onVisibleChange = this.onVisibleChange,
        dropdownVisible = this.dropdownVisible,
        getPopupContainer = this.getPopupContainer;
    var filterDropdown = isFunction(column.filterDropdown) ? column.filterDropdown(this.$createElement) : column.filterDropdown;
    var menus = filterDropdown ? h("div", [filterDropdown]) : h("div", {
      "class": "".concat(filterPrefixCls, "-dropdown")
    }, [filterMenu, h("div", {
      "class": "".concat(filterPrefixCls, "-dropdown-btns")
    }, [h("a", {
      "class": "".concat(filterPrefixCls, "-dropdown-link confirm"),
      "on": {
        "click": handleConfirm
      }
    }, ["\u786E\u5B9A"]), h("a", {
      "class": "".concat(filterPrefixCls, "-dropdown-link clear"),
      "on": {
        "click": handleClearFilters
      }
    }, ["\u91CD\u7F6E"])])]);
    var props = {
      trigger: ['click'],
      visible: dropdownVisible,
      getPopupContainer: getPopupContainer,
      closeOnSelect: false,
      theme: theme
    };
    var on = {
      'visible-change': onVisibleChange
    };
    return h(Dropdown, {
      "props": _objectSpread({}, props),
      "on": _objectSpread({}, on)
    }, [h("template", {
      "slot": "trigger"
    }, [filterIcon]), h("template", {
      "slot": "overlay"
    }, [menus])]);
  }
};